export class LocationList {
    constructor(App) {
        this.list = document.querySelector('.list');
        this.groups = this.list.querySelectorAll('.group');
        this.items = this.list.querySelectorAll('.item');
        this.App = App;

        this.update();
    }
    filterByCategory(category = '_all_') {
        this.groups.forEach(group => {
            if (category == '_all_') return this.groups.forEach(g => {
                g.classList.remove('is-hidden');
            });

            if (group.dataset.category != category) {
                group.classList.add('is-hidden');
            } else {
                group.classList.remove('is-hidden');
            }
        })
    }
    search(term) {
        console.log(term);
    }
    update() {
        if (!this.App.state.isFiltered) return;

        this.groups.forEach(group => {
            let thisIsTheGroup = this.App.state.activeCategories.includes(group.dataset.category);
            thisIsTheGroup ? group.classList.remove('is-hidden') : group.classList.add('is-hidden');
        })
    }
}